module.exports = __webpack_public_path__ + "icon-o2o-offer-blue.39498b3f9798b27d620e.svg";